module.exports = __webpack_public_path__ + "img/estuco_para_exteriores.b3cf0a34.png";